<div *cdkPortal class="hint-dialog">
  <ng-content select="[dialog-content]"></ng-content>
</div>
